<script lang="ts">
    import InteractiveMap from "./InteractiveMap.svelte";
    import { setupI18n, isLocaleLoaded } from './services/i18n';


    declare var lang: string; //this is specified in the index.html file to change the language

    $: if (!$isLocaleLoaded) {
        setupI18n({ withLocale: lang });
    }

//use this for all translations: {$_('stepContent.dragFileHere')}

</script>

<svelte:options immutable={true}/>
{#if $isLocaleLoaded}
    <InteractiveMap {mapType}></InteractiveMap>
{/if}
